import data from '../data/api.json'
// pages/api does not work as expected. Just converting
// to a service with static content
export default async function handler (url) {

    const slugPath = url.split('api').pop()
    let result = data[slugPath]
    if (!result ) result = data[slugPath.split('?')[0]]
    return {data: result}
}